import React, { useState } from "react";
import { Mail, Eye } from "lucide-react";

/**
 * Click-to-reveal email component to prevent scraping.
 * Email is split and only assembled on user interaction.
 */
const RevealEmail = ({
  user = "coupe.ch2026",
  domain = "gmail.com",
  className = "",
  testid = "reveal-email",
}) => {
  const [shown, setShown] = useState(false);
  const email = `${user}@${domain}`;

  if (shown) {
    return (
      <a
        href={`mailto:${email}`}
        className={`inline-flex items-center gap-2 hover:text-[#E60012] transition-colors break-all ${className}`}
        data-testid={`${testid}-link`}
      >
        <Mail className="w-4 h-4 shrink-0" />
        <span>{email}</span>
      </a>
    );
  }

  return (
    <button
      type="button"
      onClick={() => setShown(true)}
      data-testid={testid}
      className={`inline-flex items-center gap-2 px-3 py-1.5 border border-white/20 hover:border-[#E60012] hover:text-[#E60012] font-condensed uppercase tracking-[0.18em] text-xs transition-colors ${className}`}
      aria-label="Afficher le courriel de contact"
    >
      <Eye className="w-3.5 h-3.5" />
      Voir le courriel
    </button>
  );
};

export default RevealEmail;
